import HeaderPage from "../../../shared/components/HeaderPage/HeaderPage";
import use123zapStore from "../../../context/123zapStore";

import TemplateAddContent from "./TemplateAddContent";
import { useTemplateOptions } from "./useTemplateOptions";

function TemplatePageAdd() {
  const featureAccess = use123zapStore((state) => state.featureAccess);

  const templateData = useTemplateOptions(featureAccess);

  return (
    <>
      <HeaderPage />
      <TemplateAddContent templateData={templateData} isLoading={false} />
    </>
  );
}

export default TemplatePageAdd;
